import { Button } from "@fluentui/react-components";
import { useState } from "react";
import IDimension from "../../../models/admin/IDimension";
import { ThresholdInput } from "../ThresholdInput";
import AdditionalDelaySettings from "./AdditionalDelaySettings";

export const DimensionDetails: React.FunctionComponent<
  IDimensionDetailsProps
> = (props: IDimensionDetailsProps) => {
  const [refreshData, setRefreshData] = useState(false);
  const isTurnaroundSufficiency =
    props.selectedDimensionDetails?.name === "turnaroundSufficiency";
  const [resetTrigger, setResetTrigger] = useState(0);
  return (
    <>
      {props.selectedDimensionDetails && (
        <div data-testid="dimension-details">
          <ThresholdInput
            onChangeThresholdValue={props.onChangeThresholdValue}
            selectedDimension={props.selectedDimensionDetails}
            resetTrigger={resetTrigger}
          />
          {isTurnaroundSufficiency && (
            <AdditionalDelaySettings
              refreshData={refreshData}
              setRefreshData={setRefreshData}
              resetTrigger={resetTrigger}
            />
          )}
          <Button
            style={{ marginRight: "8px" }}
            onClick={(_e) => {
              props.onCancelDimension();
              setResetTrigger((prev) => prev + 1);
            }}
          >
            Cancel
          </Button>
          <Button
            appearance="primary"
            data-testid="save-dimension"
            onClick={(_e) => {
              props.onSaveDimension(props.selectedDimensionDetails);
              isTurnaroundSufficiency && setRefreshData(true);
            }}
          >
            Save
          </Button>
        </div>
      )}
    </>
  );
};

export interface IDimensionDetailsProps {
  selectedDimensionDetails?: IDimension;
  onSaveDimension: any;
  onChangeThresholdValue: any;
  onCancelDimension: any;
}
